<template>
  <div style="border: solid; border-color: black; border-width: 1px; border-radius: 25px; margin-top: 30px; padding: 10px">
    <div class="text-center">
      <div class="row">
        <div class="col-12" style="font-weight:bold; font-size: 22px; color: #545454; margin-left: 0px">
          {{graph_title}}
        </div>
        {{graph_desc}}
      </div>
      <div style="margin-top: 40px" v-if="!loading && !chart_data">
        <h3>-no data available-</h3>
      </div>
    </div>
    <div style="margin-left: -80px;margin-right: -100px">
      <GChart
          v-if="!loading && chart_data"
          :resizeDebounce="500"
          :type="chart_type"
          :data="chart_data"
          :options="{
                    height: graph_height,
                    titleTextStyle: {
                        color: 'black',
                        fontSize: 27,
                        bold: false,
                        italic: false
                    },
                    legend: { position: 'top', alignment: 'center', textStyle: {color: 'black'} },
                    backgroundColor: { fill:'transparent' },
                    lineWidth: 2,
                    colors: ['black','red','green','blue','orange','purple','grey'],
                    hAxis:{
                        gridlines:{ color: 'transparent' },
                        textStyle:{ color: 'black' },
                        titleTextStyle:{ color: 'black', italic: false, fontSize: 18 },
                        baselineColor:{ color: 'black' },
                        format: date_format
                    },

                    explorer: { actions: ['dragToZoom'], axis: 'horizontal', keepInBounds: true },

                    vAxis:{
                        textStyle:{ color: 'black' },
                        titleTextStyle:{ color: 'black', italic: false, fontSize: 18 },
                        baselineColor:{ color: 'black' },
                        viewWindowMode:'explicit',
                        viewWindow:vw_window
                    },

                    titlePosition:{ color: 'black' },
                    crosshair:{ color: 'black' }
                }"

          :settings="{ packages: ['corechart'] }"
      />
      <div v-if="loading" style="height:150px; margin-top:260px">
        <div class="text-center text-primary">
          <b-spinner class="align-middle"></b-spinner>
          <strong style="margin-left:20px">Loading...</strong>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {GChart} from 'vue-google-charts'
import datePicker from 'vue-bootstrap-datetimepicker';

export default {

  components: {
    GChart,
    datePicker
  },
  props: {
    chart_legend: {type: Object, required: false},
    chart_data: {type: Array, required: false},
    chart_type: {type: String, required: true},
    loading: {type: Boolean, required: true},
    graph_title: {type: String, required: true},
    graph_desc: {type: String, required: false},
    graph_height: {type: String, required: true},
    view_window: {type: Object, required: false},
    date_format: {type: String, required: true},
  },

  data() {
    return {
      vw_window: null,
    };
  },
  created() {
    this.vw_window = this.view_window
    this.check_range()
  },
  methods: {
    async update_view_window() {
      if (this.vw_window == null)
        this.vw_window = this.view_window
      else
        this.vw_window = null
      this.check_range()
    },
    check_range() {
      if (this.chart_data && this.vw_window) {
        var max = Math.max(...this.chart_data.filter((_, i) => i > 0).map(i => i[1]))
        var min = Math.min(...this.chart_data.filter((_, i) => i > 0).map(i => i[1]))

        if (min < this.vw_window.min) {
          this.vw_window.min = min
        }
        if (max > this.vw_window.max) {
          this.vw_window.max = max
        }
      }
    }
  }
}

</script>

